import React, { useMemo } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Box, Button } from '@mui/material';
import { East } from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import Bowser from 'bowser';
import { useTranslation } from 'react-i18next';
import { DISPLAY_CLIENT_NAME } from '../../../environment';
import { oktaConfig } from '../../../oktaConfig';
import { NarrowFooter } from '../../Header/Header';
import { loginStyles } from './Login.style';

export const LoginPage = () => {
    const { oktaAuth, authState } = useOktaAuth();
    const history = useHistory();
    const { t } = useTranslation();

    const isUnsupportedSafari = useMemo(() => {
        const browser = Bowser.getParser(window.navigator.userAgent);
        return browser.satisfies({ safari: '<15' });
    }, []);

    if (authState && authState.isAuthenticated) {
        history.push('/');
        return null;
    }

    if (!oktaConfig.idp && !oktaConfig.multipleIDP) {
        oktaAuth.signInWithRedirect();
        return null;
    }

    const loginWithIDP = idp => async () => {
        try {
            await oktaAuth.token.getWithRedirect({
                idp
            });
        } catch (error) {
            console.log(error);
        }
    };

    const loginWithCustomEmail = async () => {
        try {
            await oktaAuth.signInWithRedirect();
        } catch (error) {
            console.log(error);
        }
    };

    const oktaIDPs = [];
    if (oktaConfig.multipleIDP) {
        Object.keys(oktaConfig.multipleIDP).forEach(key => {
            oktaIDPs.push({
                idp: oktaConfig.multipleIDP[key],
                text: `${key} login`
            });
        });
    } else if (oktaConfig.idp) {
        oktaIDPs.push({
            idp: oktaConfig.idp,
            text: `${DISPLAY_CLIENT_NAME} Login`
        });
    }

    return (
        <Box sx={loginStyles.container}>
            <Box sx={loginStyles.page}>
                <Box sx={loginStyles.card}>
                    {oktaIDPs.map(idpObj => (
                        <Button
                            sx={loginStyles.loginButton}
                            variant='contained'
                            key={idpObj.idp}
                            onClick={loginWithIDP(idpObj.idp)}
                            endIcon={<East sx={loginStyles.endIcon} />}>
                            {idpObj.text}
                        </Button>
                    ))}
                    <Button sx={loginStyles.loginGuestButton} type='submit' onClick={loginWithCustomEmail}>
                        {t('login.guest_email_login')}
                    </Button>
                </Box>
                {isUnsupportedSafari && (
                    <Box sx={loginStyles.messageCard}>
                        <Box sx={loginStyles.messageTitle}>{t('login.browser_performance_disclaimer_title')}</Box>
                        <Box sx={loginStyles.messageText}>{t('login.browser_performance_disclaimer_message')}</Box>
                    </Box>
                )}
            </Box>
            <Box sx={loginStyles.footer}>
                <NarrowFooter />
            </Box>
        </Box>
    );
};
